<div class="header" i18n [attr.data-testid]="'card-editor-header'">
  {{ title }}
</div>

<div
  class="container flex flex-row flex-nowrap"
  [attr.data-testid]="'card-editor-container'"
>
  <div class="preview" [attr.data-testid]="'card-preview-section'">
    <ms-card
      [card]="$any(card)"
      [message]="message"
      [package]="package"
      mode="READ"
    ></ms-card>
  </div>
  <div class="form" [attr.data-testid]="'card-form-section'">
    <gosu-image-picker
      [(value)]="card.image"
      (valueChange)="onChanged()"
      [useCode]="true"
      [style.width]="card.layout === 'share-add-friend' ? '215px' : null"
      [style.height]="card.layout === 'share-add-friend' ? '268px' : null"
      [attr.data-testid]="'card-image-picker'"
    >
    </gosu-image-picker>

    <br />

    @if (card.layout === 'share-add-friend') {
      <p class="text-sm mb-3" i18n>
        圖片建議尺寸為 215 * 268px，圖片連結必須為 https
      </p>

      <mat-accordion displayMode="flat" multi="true">
        @for (button of card.buttons; track $index; let index = $index) {
          <mat-expansion-panel expanded>
            <mat-expansion-panel-header i18n>
              按鈕{{ index + 1 }}
            </mat-expansion-panel-header>

            <mat-form-field floatLabel="always" legacyAppearance>
              <mat-label i18n>動作</mat-label>
              @if (button.type === 'add-friend') {
                <input matInput disabled i18 value="加入官方帳號" />
              }
              @if (button.type === 'share-message') {
                <input matInput disabled i18n value="分享訊息" />
              }
            </mat-form-field>

            <mat-form-field floatLabel="always" legacyAppearance>
              <mat-label i18n>文字</mat-label>
              <input
                matInput
                i18n
                value="加入官方帳號"
                [(ngModel)]="button.label"
                (ngModelChange)="onChanged()"
              />
              <gosu-validator
                [(ngModel)]="button.label"
                [rules]="{ required: true }"
                [offsetY]="20"
              ></gosu-validator>
            </mat-form-field>

            <mat-form-field floatLabel="always" legacyAppearance>
              <mat-label i18n
                >背景顏色{{ button['backgroundColor'] }}</mat-label
              >
              <gosu-color-picker
                [(value)]="button['backgroundColor']"
                (valueChange)="onChanged()"
                format="hex"
              >
              </gosu-color-picker>
              <gosu-validator
                [(ngModel)]="button['backgroundColor']"
                [rules]="{ required: true }"
                [offsetY]="20"
              ></gosu-validator>
            </mat-form-field>

            <mat-form-field floatLabel="always" legacyAppearance>
              <mat-label i18n>文字顏色{{ button['color'] }}</mat-label>
              <gosu-color-picker
                [(value)]="button['color']"
                (valueChange)="onChanged()"
                format="hex"
              >
              </gosu-color-picker>
              <gosu-validator
                [(ngModel)]="button['color']"
                [rules]="{ required: true }"
                [offsetY]="20"
              ></gosu-validator>
            </mat-form-field>
          </mat-expansion-panel>
        }
      </mat-accordion>
    } @else {
      <mat-form-field legacyAppearance>
        <mat-label i18n>標題</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="card.title"
          (ngModelChange)="onChanged()"
          [attr.data-testid]="'card-title-input'"
        />
        <gosu-validator
          [(ngModel)]="card.title"
          [rules]="{ required: true }"
          [offsetY]="20"
        ></gosu-validator>
      </mat-form-field>

      <mat-form-field legacyAppearance>
        <mat-label i18n>內容</mat-label>
        <textarea
          matInput
          [(ngModel)]="card.content"
          (ngModelChange)="onChanged()"
          [attr.data-testid]="'card-content-textarea'"
        ></textarea>
        <gosu-validator
          [(ngModel)]="card.content"
          [rules]="{ required: true }"
          [offsetY]="20"
        ></gosu-validator>
      </mat-form-field>

      <mat-accordion
        displayMode="flat"
        multi="false"
        [attr.data-testid]="'card-buttons-accordion'"
      >
        @for (button of card.buttons; track $index; let index = $index) {
          <mat-expansion-panel
            #buttonPanel
            [attr.data-testid]="'button-panel-' + index"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 1 + index }}. {{ button.label }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-action-row>
              <button
                mat-button
                (click)="remove(index)"
                i18n
                [attr.data-testid]="'delete-button-' + index"
              >
                刪除
              </button>
            </mat-action-row>

            <mat-form-field floatLabel="always" class="select" legacyAppearance>
              <mat-label i18n>類型</mat-label>
              <mat-select
                [(ngModel)]="button.type"
                (ngModelChange)="onTypeChanged(button)"
                placeholder="類型"
                i18n-placeholder="類型"
                [attr.data-testid]="'button-type-select-' + index"
              >
                @if (package.enabledActions.uri) {
                  <mat-option
                    value="uri"
                    i18n
                    [attr.data-testid]="'uri-option-' + index"
                  >
                    連結 / 檔案
                  </mat-option>
                }

                @if (package.enabledActions.message) {
                  <mat-option
                    value="message"
                    i18n
                    [attr.data-testid]="'message-option-' + index"
                  >
                    說話
                  </mat-option>
                }

                @if (package.enabledActions.next) {
                  <mat-option
                    value="next"
                    i18n
                    [attr.data-testid]="'next-option-' + index"
                  >
                    下一個流程
                  </mat-option>
                }

                @if (packageFactoryService.enablePromotionChannel$ | async) {
                  <ng-container>
                    @if (package.enabledActions.shareMessageThroughPromotion) {
                      <mat-option
                        value="share-message-through-promotion"
                        i18n
                        [attr.data-testid]="'share-promotion-option-' + index"
                      >
                        分享機器人 (推廣通路)
                      </mat-option>
                    }
                    @if (package.enabledActions.addThroughPromotion) {
                      <mat-option
                        value="add-through-promotion"
                        i18n
                        [attr.data-testid]="'add-promotion-option-' + index"
                      >
                        加入機器人 (推廣通路)
                      </mat-option>
                    }
                  </ng-container>
                }
                @if (konamiCode.unlock$ | async) {
                  @if (package.enabledActions.shareMessage) {
                    <mat-option value="share-message" i18n>
                      分享訊息
                    </mat-option>
                  }

                  @if (package.enabledActions.addFriend) {
                    <mat-option
                      [disabled]="
                        !isButtonTypeNotIn([
                          'add-friend',
                          'share-add-friend',
                        ]) &&
                        button.type !== 'add-friend' &&
                        button.type !== 'share-add-friend'
                      "
                      value="add-friend"
                      i18n
                    >
                      加入 LINE 官方帳號
                    </mat-option>
                  }
                  @if (package.enabledActions.addFriendThroughShare) {
                    <mat-option
                      [disabled]="
                        !isButtonTypeNotIn([
                          'add-friend',
                          'share-add-friend',
                        ]) &&
                        button.type !== 'add-friend' &&
                        button.type !== 'share-add-friend'
                      "
                      value="share-add-friend"
                      i18n
                    >
                      分享訊息並邀請好友加入 LINE 官方帳號
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>

            @if (button.type === 'share-message') {
              <div class="flex items-center gap-1">
                <mat-form-field
                  floatLabel="always"
                  class="select"
                  legacyAppearance
                  *asyncJob="
                    messageManagementService.selectShareMessagesTree$;
                    let selectMessagesTree
                  "
                >
                  <mat-label i18n>
                    <div class="flex items-center gap-1">
                      分享訊息
                      <mat-icon
                        [matTooltip]="option_tooltip"
                        class="!text-[20px] !w-[20px] !h-[20px]"
                        >help</mat-icon
                      >
                      <ng-template #option_tooltip>
                        <ms-share-message-hint
                          [type]="'share-message'"
                        ></ms-share-message-hint>
                      </ng-template>
                    </div>
                  </mat-label>
                  <input
                    matInput
                    [matTreePicker]="treePicker"
                    readonly
                    class="cursor-pointer"
                    [value]="button.shareMessageName ?? ''"
                  />
                  <gosu-validator
                    [(ngModel)]="button.shareMessageName"
                    [rules]="{ required: true }"
                    [offsetY]="20"
                  ></gosu-validator>
                  <button mat-icon-button matSuffix class="!w-6 !h-6">
                    <mat-icon class="!w-5 !h-5">arrow_drop_down</mat-icon>
                  </button>
                  <mat-tree-picker
                    #treePicker
                    side="right"
                    [dataSource]="filterDataSource(selectMessagesTree)"
                  >
                    <mat-tree-picker-node
                      *matTreePickerNodeDef="let item"
                      (selected)="selectMessage(button, $event, treePicker)"
                      [attr.disabled]="
                        item.type === 'message' && !item.isShareable ? '' : null
                      "
                    >
                      @if (
                        ['create-folder', 'create-message'].includes(item.type)
                      ) {
                        <div class="text-center px-5 flex items-center gap-1">
                          <mat-icon class="!leading-none">add</mat-icon>
                          <span i18n>{{ item.name }}</span>
                        </div>
                      } @else {
                        <p class="truncate" [matTooltip]="item.name">
                          {{ item.name }}
                        </p>
                      }
                    </mat-tree-picker-node>
                  </mat-tree-picker>
                </mat-form-field>
                @if (button.messageId) {
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="editMessage(button)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                } @else {
                  <button
                    mat-icon-button
                    matSuffix
                    matTooltip="建立分享訊息"
                    i18n-matTooltip="建立分享訊息"
                    (click)="createMessage(button)"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </div>
            }

            @if (button.type === 'share-add-friend') {
              <div class="flex items-center gap-1">
                <mat-form-field
                  floatLabel="always"
                  class="select"
                  legacyAppearance
                  *asyncJob="
                    messageManagementService.selectAddFriendThroughShareMessagesTree$;
                    let selectMessagesTree
                  "
                >
                  <mat-label i18n
                    ><div class="flex items-center gap-1">
                      分享訊息
                      <mat-icon
                        [matTooltip]="option_tooltip"
                        class="!text-[20px] !w-[20px] !h-[20px]"
                        >help</mat-icon
                      >
                      <ng-template #option_tooltip>
                        <ms-share-message-hint
                          [type]="'share-add-friend'"
                        ></ms-share-message-hint>
                      </ng-template></div
                  ></mat-label>
                  <input
                    matInput
                    [matTreePicker]="treePicker"
                    readonly
                    class="cursor-pointer"
                    [value]="button.shareMessageName ?? ''"
                  />
                  <gosu-validator
                    [(ngModel)]="button.shareMessageName"
                    [rules]="{ required: true }"
                    [offsetY]="20"
                  ></gosu-validator>
                  <button mat-icon-button matSuffix class="!w-6 !h-6">
                    <mat-icon class="!w-5 !h-5">arrow_drop_down</mat-icon>
                  </button>
                  <mat-tree-picker
                    #treePicker
                    side="right"
                    [dataSource]="selectMessagesTree"
                  >
                    <mat-tree-picker-node
                      *matTreePickerNodeDef="let item"
                      (selected)="selectMessage(button, $event, treePicker)"
                      [attr.disabled]="
                        item.type === 'message' && !item.isAddFriendThroughShare
                          ? ''
                          : null
                      "
                    >
                      @if (
                        ['create-folder', 'create-message'].includes(item.type)
                      ) {
                        <div class="text-center px-5 flex items-center gap-1">
                          <mat-icon class="!leading-none">add</mat-icon>
                          <span i18n>{{ item.name }}</span>
                        </div>
                      } @else {
                        {{ item.name }}
                      }
                    </mat-tree-picker-node>
                  </mat-tree-picker>
                </mat-form-field>
                @if (button.messageId) {
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="editMessage(button)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                } @else {
                  <button
                    mat-icon-button
                    matSuffix
                    matTooltip="建立分享訊息"
                    i18n-matTooltip="建立分享訊息"
                    (click)="createMessage(button)"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </div>
            }

            <mat-form-field legacyAppearance>
              <mat-label i18n>按鈕文字</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="button.label"
                (ngModelChange)="onChanged()"
                [attr.data-testid]="'button-label-input-' + index"
              />
              <gosu-validator
                [(ngModel)]="button.label"
                [rules]="{ required: true }"
                [offsetY]="20"
              ></gosu-validator>
            </mat-form-field>

            @if (button.type === 'uri') {
              <ng-container>
                <mat-form-field floatLabel="always" legacyAppearance>
                  <input
                    matInput
                    type="text"
                    placeholder="網址"
                    i18n-placeholder="網址"
                    [(ngModel)]="button.uri"
                    (ngModelChange)="onChanged()"
                    [attr.data-testid]="'button-uri-input-' + index"
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="openUrlBuilderDialog(button)"
                    matTooltip="編輯 UTM 參數"
                    i18n-matTooltip="編輯 UTM 參數"
                  >
                    <mat-icon> edit </mat-icon>
                  </button>
                  <gosu-validator
                    [(ngModel)]="button.uri"
                    [rules]="{ required: true, uri: true }"
                    [offsetY]="20"
                  >
                  </gosu-validator>
                </mat-form-field>

                <div class="text-right">
                  <button
                    mat-button
                    (file)="uploadFile(button, $event)"
                    i18n
                    [attr.data-testid]="'upload-file-button-' + index"
                  >
                    上傳檔案
                  </button>
                </div>
              </ng-container>
            }

            @if (button.type === 'message') {
              <mat-form-field legacyAppearance>
                <mat-label i18n>訊息內容</mat-label>
                <input
                  matInput
                  type="text"
                  [(ngModel)]="button.text"
                  (ngModelChange)="onChanged()"
                  [attr.data-testid]="'button-message-input-' + index"
                />
                <gosu-validator
                  [(ngModel)]="button.text"
                  [rules]="{ required: true }"
                  [offsetY]="20"
                ></gosu-validator>
              </mat-form-field>
            }

            @if (button.type === 'next') {
              <mat-form-field legacyAppearance>
                <mat-label i18n>引導文字</mat-label>
                <input
                  matInput
                  type="text"
                  [(ngModel)]="button.text"
                  (ngModelChange)="onChanged()"
                  [attr.data-testid]="'button-next-input-' + index"
                />
                <gosu-validator
                  [(ngModel)]="button.text"
                  [rules]="{ required: true }"
                  [offsetY]="20"
                ></gosu-validator>
              </mat-form-field>
            }

            @if (button.type === 'share-message-through-promotion') {
              <mat-form-field legacyAppearance>
                <mat-label i18n>推廣通路</mat-label>
                <mat-select
                  [(ngModel)]="button['promotionId']"
                  (ngModelChange)="onChanged()"
                  [attr.data-testid]="'promotion-select-' + index"
                >
                  @for (promotion of promotions$ | async; track promotion.id) {
                    <mat-option
                      [value]="promotion.id"
                      [attr.data-testid]="'promotion-option-' + promotion.id"
                    >
                      {{ promotion.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>

      <div class="add-card-button-wrap">
        @if (card.buttons.length < 4) {
          <button
            mat-flat-button
            class="add-card-button"
            (click)="add()"
            i18n
            [attr.data-testid]="'add-button'"
          >
            <mat-icon>add</mat-icon>
            新增按鈕
          </button>
        }
      </div>
    }
  </div>
</div>

<div class="footer" [attr.data-testid]="'card-editor-footer'">
  <div class="text">
    <span i18n> 卡片適用： </span>
    <span [attr.data-testid]="'line-platform-status'">
      <mat-icon>check_circle</mat-icon>
      LINE、
    </span>
    <span
      [class.disabled]="card.buttons.length >= 4"
      [attr.data-testid]="'facebook-platform-status'"
    >
      <mat-icon>
        {{
          card.buttons.length >= 4 ? 'radio_button_unchecked' : 'check_circle'
        }}
      </mat-icon>
      Facebook
    </span>
    <mat-icon
      [matTooltip]="platformText"
      [attr.data-testid]="'platform-info-icon'"
      >info</mat-icon
    >
  </div>

  <button
    mat-button
    (click)="confirm()"
    color="primary"
    i18n
    [attr.data-testid]="'confirm-button'"
  >
    確定
  </button>
</div>

<ng-template #platformText>
  <div class="platform-text" [attr.data-testid]="'platform-info-tooltip'">
    <mat-icon>info</mat-icon>
    <div class="content">
      <div class="text">
        <img src="./assets/icon-line.png" alt="" />
        <span i18n>
          LINE卡片訊息規範：<br />
          • 一個訊息內最多包含10張卡片<br />
          • 每張訊息最多包含4個按鈕
        </span>
      </div>
      <div class="text">
        <img src="./assets/icon-fb.png" alt="" />
        <span i18n>
          Facebook卡片訊息規範：<br />
          • 一個訊息內最多包含10張卡片<br />
          • 每張訊息最多包含3個按鈕<br />
          • 如您欲使用留言轉私訊的功能（起始點為「使用者回應文章」），則基於
          Facebook 官方限制，只可以回覆 1 張卡片。
        </span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #uploadProgressDialog>
  <div class="container" [attr.data-testid]="'upload-progress-dialog'">
    <div class="upload-progress">
      <h2 i18n>檔案上傳中，請稍後</h2>
      <mat-progress-bar
        mode="determinate"
        [value]="uploadProgress"
        color="primary"
        [attr.data-testid]="'upload-progress-bar'"
      >
      </mat-progress-bar>
    </div>
  </div>
</ng-template>
